import { DisplayGroupId, TFComponent } from '@types';
import { BodyPanel } from './bodyPanel';
import { BottomPanel } from './bottomPanel';
import { ColumnContainer } from './columnContainer';
import { LeftPanel } from './leftPanel';
import { PageContainer } from './pageContainer';
import { RowContainer } from './rowContainer';
import { TopPanel } from './topPanel';

const bodyPanel: TFComponent = {
	id: DisplayGroupId.bodyPanel,
	name: 'bodyPanel',
	component: BodyPanel,
};

const bottomPanel: TFComponent = {
	id: DisplayGroupId.bottomPanel,
	name: 'bottomPanel',
	component: BottomPanel,
};

const columnContainer: TFComponent = {
	id: DisplayGroupId.columnContainer,
	name: 'columnContainer',
	component: ColumnContainer,
};

const leftPanel: TFComponent = {
	id: DisplayGroupId.leftPanel,
	name: 'leftPanel',
	component: LeftPanel,
};

const pageContainer: TFComponent = {
	id: DisplayGroupId.pageContainer,
	name: 'pageContainer',
	component: PageContainer,
};

const rowContainer: TFComponent = {
	id: DisplayGroupId.rowContainer,
	name: 'rowContainer',
	component: RowContainer,
};

const topPanel: TFComponent = {
	id: DisplayGroupId.topPanel,
	name: 'topPanel',
	component: TopPanel,
};

export const commonDisplayGroups = {
	bodyPanel,
	bottomPanel,
	columnContainer,
	leftPanel,
	pageContainer,
	rowContainer,
	topPanel,
};
